import { useSvgFilterId } from '@nucleus/react-components';
import React from 'react';

/** Icon representing a solid circle with play icon, used by Sermon Dropdown actions menu */
export const IconCirclePlaySolid = (props: React.SVGAttributes<SVGSVGElement>): JSX.Element => {
  const { generateId, generateUrl } = useSvgFilterId();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs>
        <filter
          id={generateId('a')}
          width="135.6%"
          height="141.6%"
          x="-16.7%"
          y="-19.5%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dx="2" dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="10" />
          <feColorMatrix
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g fill="currentColor" fillRule="nonzero" filter={generateUrl('a')} transform="translate(-12 -18)">
        <path d="M24 18c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12Zm-1.446 7.168A1 1 0 0 0 21 26v8a1 1 0 0 0 1.554.832l6-4a1 1 0 0 0 0-1.664Z" />
      </g>
    </svg>
  );
};
